export default __webpack_public_path__ + "static/completeCheck-8cac73ab8d65fec28b16ed926623248b.png";